// Shared helpers for building the account-update request body.
//
// Historically every screen built this body by string concatenation, e.g.
//   '{ ... "full_name": "' + username + '" ... }'
// which turns a null/undefined name into the literal string "null" and then
// POSTs it, permanently overwriting the real name (typically right after
// switching login accounts, before the account GET has resolved).
//
// buildAccountJsonBody serializes with JSON.stringify so null stays null and
// escaping is always valid, and accountNameLoaded gives callers one guard to
// check the account has actually loaded before writing it back.

export function buildAccountJsonBody(fields) {
  return JSON.stringify(fields);
}

export function buildProsArray(userId, userSettingsIds) {
  if (userSettingsIds === null) {
    return [userId];
  }

  const pros = userSettingsIds.split(",").filter(id => id !== "" && id !== userId);
  pros.push(userId);
  return pros;
}

export function buildOrgsArray(org, orgs) {
  if (orgs === null) {
    return [org];
  }

  return orgs.split(",");
}

// True once the account's full_name has actually been fetched. Only null /
// undefined mean "not loaded yet" — any string (including "null", "Null" or "")
// is a real value the user is entitled to, and is written back unchanged.
// Guards the account POST so a not-yet-loaded screen can't send full_name as
// the string "null".
export function accountNameLoaded(name) {
  return name !== null && name !== undefined;
}
